<template>
  <div>
    <AdvertismentDialog :chosenAdvert="chosenAdvert" ref="AdvCard"></AdvertismentDialog>
    <FullImageDialog :chosenAdvert="chosenAdvert" ref="fullImageDialogOpen"></FullImageDialog>
    <v-hover>
      <v-card
        replace
        slot-scope="{ hover }"
        :class="`elevation-${hover ? 12 : 0}`"
       
        height="100%"
        
        style="border:solid 1px black;"
        @click.stop="$refs.AdvCard.openDialog()"
        >
        <!--Title-->
        <v-row class="ma-0 pa-0">
          <v-col class="ma-0 pa-0">
             <p class="font-weight-bold title pa-0 pt-4 ma-0 text-center" style="display: -webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical; overflow: hidden;">
              {{chosenAdvert.mainDescription}}
            </p>
          </v-col>
        </v-row>
        <!--Image-->
        <v-row class="ma-0 pa-0 ">
          <v-col :grow="$vuetify.breakpoint.xs" :shrink="$vuetify.breakpoint.smAndUp" class="ma-0 pa-0 mt-3">
            <v-img :src="chosenAdvert.image" width="100%" height="120px" :aspect-ratio="1.77"/>
          </v-col>
        </v-row>
        <!--Text-->
        <!-- <v-row class="ma-0 pa-0">
          <v-col class="ma-0 pa-0">
            <div style="display: -webkit-box; -webkit-line-clamp: 7; -webkit-box-orient: vertical; overflow: hidden;" class="pl-3 pt-3 subtitle-2">
              <span class="body-1">{{chosenAdvert.subDescriptionOne}}</span><br>
              <span>{{chosenAdvert.subDescriptionTwo}}</span> <br>
              <span>{{chosenAdvert.subDescriptionThree}}</span><br>
              <span>{{chosenAdvert.subDescriptionFour}}</span>
            </div>
          </v-col>
        </v-row> -->
        <!--Click to see more-->
        <!-- <v-row class="ma-0 pa-0">
          <v-col class="ma-0 pa-0">
            <p class="subtitle-1 font-weight-bold text-center ma-0 pa-0">Click to see more</p>
          </v-col>
        </v-row> -->
      </v-card>
    </v-hover>
  </div>
</template>

<script>
import FullImageDialog from "@/pages/frontpage/components/dialog/full_image_dialog.vue";
import AdvertismentDialog from "@/pages/frontpage/components/dialog/advertismentDialog.vue";
import messages from "../../modules/lang/main/export";
export default {
  i18n: { messages },
  components:{
    AdvertismentDialog,
    FullImageDialog
  },
  data(){
    return{
      advertisment:[
        {
          mainDescription: this.$t("Customise your frontpage"),
          subDescriptionOne: this.$t("As an logged in user, you will be able to define your own wenewz frontpage profiles"),
          subDescriptionTwo: this.$t("This means that you will be able to add any location and #interest tags that you want, to get exactly the news that interests you"),
          readMore: this.$t("Read more"),
          image:"/frontpageProfile.png",
          link:"",
          component:"",
          color: "",
          cardInfo:[
            {
              title: this.$t("Get your newz out there"),
              image:"/frontpageProfile.png",
              cardDescriptionOne: this.$t("As an logged in user, you will be able to custom make wenewz to your liking"),
              cardDescriptionTwo: this.$t("This you can do through the frontpage editor within your personal pages"),
              cardDescriptionThree: this.$t("Here you can create different profiles of what you would like to see"),
              cardDescriptionFour: this.$t("Meaning: you can make a profile named sport"),
              cardDescriptionFive: this.$t("Here you select your prioritised locations: ex England"),
              cardDescriptionSix: this.$t("Then lastly you can select the interest tags that you wish to look closer upon"),
              cardDescriptionSeven: this.$t("These can be: #sport, #corona and #politics"),
              cardDescriptionEight: this.$t("Now articles that contain these tags will be prioritised and displayed for you on the frontpage"),
            }
          ]
        },
        {
          mainDescription: this.$t("Create an account and publish your news"),
          subDescriptionOne: this.$t("As an logged in user, you will be able to create and publish your own articles"),
          subDescriptionTwo: this.$t("You will have the possibility to add location and #interest tags"),
          readMore: this.$t("Read more"),
          image:"/create.png",
          link:"",
          component:"",
          color: "",
          cardInfo:[
            {
              title: this.$t("Get your newz out there"),
              image: "/create.png",
              cardDescriptionOne: this.$t("As an logged in user, you will be able to create and publish your own articles"),
              cardDescriptionTwo: this.$t("The option of adding tags both location of the newz, aswell as #tags"),
              cardDescriptionThree: this.$t("Not only that! you will also have the options of"),
              cardDescriptionFour: this.$t("Enabling or disabling comments on the article"),
              cardDescriptionFive: this.$t("To publish or unpublish the article, and simply save it for later use"),
              cardDescriptionSix: this.$t("And to select what personal information you wish to display through settings"),
              cardDescriptionSeven: "",
              cardDescriptionEight: ""
            }
          ]
        },
        {
          mainDescription: this.$t("Wenewz advertisment"),
          subDescriptionOne: this.$t("Wenewz is a hyper intelligent hybrid between online newspaper and social media, focusing on bringing local news to you"),
          subDescriptionTwo: "",
          readMore: "",
          image: "/whatItIsJpeg.jpg",
          link: "",
          component: "",
          color: "",
          // cardInfo:[
          //   {
          //     title: "Get your newz out there",
          //     image: "",
          //     cardDescriptionOne: "With Wenewz articles, the writer have the opportunity to add locationtags to it.",
          //     cardDescriptionTwo: "Which in return means that the location of the article, can be pinpointed down to the street if the writer chooses to.",
          //     cardDescriptionThree: "You as a reader, will then be able to easily search the location you wish to see newz from, and quickly it will be displayed.",
          //     cardDescriptionFour: "As an logged in user, you will be able to customise your own frontpage to frequently check and update for news that interests you.",
          //     cardDescriptionFive: "",
          //     cardDescriptionSix: "",
          //     cardDescriptionSeven: "",
          //     cardDescriptionEight: ""
          //   }
          // ]
        },
        {
          mainDescription:this.$t("Why Wenews"),
          subDescriptionOne:this.$t("Almost no post from youths and young adults"),
          subDescriptionTwo:this.$t("The wall is perceived as random"),
          subDescriptionThree: "",
          readMore: "",
          image: "/activity.jpg",
          link: "",
          component: "",
          color: "",
          // cardInfo:[
          //   {
          //     title: "Get your newz out there",
          //     image: "",
          //     cardDescriptionOne: "We at Wenewz take pride in being an open platform, which the user can freely read any articles wanted.",
          //     cardDescriptionTwo: " We will never be hiding our articles behind a paywall, but instead focus on getting the news out to the people.",
          //     cardDescriptionThree: "Once logged in, you can freely customise your own personal frontpage, to prioritise news that are interesting for you!",
          //     cardDescriptionFour: "",
          //     cardDescriptionFive: "",
          //     cardDescriptionSix: "",
          //     cardDescriptionSeven: "",
          //     cardDescriptionEight: ""
          //   }
          // ]
        },
        {
          mainDescription:this.$t("Why Wenews"),
          subDescriptionOne: this.$t("Paywall to read even the tiniest story"),
          subDescriptionTwo: this.$t("Editor decide front page and what is of interest for you"),
          subDescriptionThree:"",
          readMore: "",
          image: "/digitalNews.jpg",
          link: "",
          component: "",
          color: "",
          // cardInfo:[
          //   {
          //     title: "Get your newz out there",
          //     image: "",
          //     cardDescriptionOne: "One of the unfortunate things with todays news pages, is that it is cluttered with news that simply isnt interesting one.",
          //     cardDescriptionTwo: "Finding something one actually wish to read more about, can be a tiresome task at times.",
          //     cardDescriptionThree: "Here at Wenewz we have created the opportunity for the user to decise exactly which news that will be prioritised.",
          //     cardDescriptionFour: "By creating one or several frontpage profiles",
          //     cardDescriptionFive: " Yes you will be able to create several different profiles, to easily get to the newz you wish to see with one click.",
          //     cardDescriptionSix: "Give it a try, and test it for yourself.",
          //     cardDescriptionSeven: "",
          //     cardDescriptionEight: ""
          //   }
          // ]
        },
        {
          mainDescription:this.$t("Why Wenews"),
          subDescriptionOne: this.$t("Same stories"),
          subDescriptionTwo: this.$t("Same sources"),
          subDescriptionThree: this.$t("Same priority"),
          subDescriptionFour: "",
          readMore: "",
          image: "/largeSameFront.jpg",
          link: "",
          component: "",
          color: "",
          // cardInfo:[
          //   {
          //     title: "Get your newz out there",
          //     image: "",
          //     cardDescriptionOne: "By logging in and creating a customised frontpage.",
          //     cardDescriptionTwo: "Wenews will be able to bring you articles that matches your criterias / wishes.",
          //     cardDescriptionThree: "Give it a try, as it is completly free to do so.",
          //     cardDescriptionFour: "",
          //     cardDescriptionFive: "",
          //     cardDescriptionSix: "",
          //     cardDescriptionSeven: "",
          //     cardDescriptionEight: ""
          //   }
          // ]
        },
        {
          mainDescription: this.$t("Why Wenews"),
          subDescriptionOne: this.$t("Find news of MY interest is a lot of clicking"),
          subDescriptionTwo: "",
          readMore: "",
          image: "/lotOfClicking.jpg",
          link: "",
          component: "",
          color: "",
          // cardInfo:[
          //   {
          //     title: "Get your newz out there",
          //     image: "",
          //     cardDescriptionOne: "You do not have to write to attract the whole world.",
          //     cardDescriptionTwo: "If your neighbour finds it interesting, then your news have great value.",
          //     cardDescriptionThree: "By logging in, you can access our article editor.",
          //     cardDescriptionFour: " Which means that you will be able to get your news out there",
          //     cardDescriptionFive: "It do not have to be a world changing news, but something that have catched your eye, or interest you.",
          //     cardDescriptionSix: "Log in and check out all the options unlocked for you by doing so.",
          //     cardDescriptionSeven: "Give it a try! After all, it is free",
          //     cardDescriptionEight: ""
          //   }
          // ]
        },
        {
          mainDescription: this.$t("Wenewz the tinder of news"),
          subDescriptionOne: this.$t("An intelligent solution giving readers easy access to free news of interest"),
          subDescriptionTwo: "",
          readMore: "",
          image: "/fullmatch.jpg",
          link: "",
          component: "",
          color: "",
          // cardInfo:[
          //   {
          //     title: "Get your newz out there",
          //     image: "",
          //     cardDescriptionOne: "In Wenews the articles are written by people like you and me.",
          //     cardDescriptionTwo: "Meaning the stories, the sources will be greatly diverse.",
          //     cardDescriptionThree: "No longer a recycling of the same story or point of view, over and over again.",
          //     cardDescriptionFour: "But a refreshing take on news, seen by a new set of eyes.",
          //     cardDescriptionFive: "",
          //     cardDescriptionSix: "",
          //     cardDescriptionSeven: "",
          //     cardDescriptionEight: ""
          //   }
          // ]
        },
        {
          mainDescription: this.$t("Wenewz the tinder of news"),
          subDescriptionOne: "",
          subDescriptionTwo: "",
          readMore: "",
          image: "/journey.jpg",
          link: "",
          component: "",
          color: "",
          // cardInfo:[
          //   {
          //     title: "Gonna be an add",
          //     image: "",
          //     cardDescriptionOne: "To Come soon",
          //     cardDescriptionTwo: "",
          //     cardDescriptionThree: "",
          //     cardDescriptionFour: "",
          //     cardDescriptionFive: "",
          //     cardDescriptionSix: "",
          //     cardDescriptionSeven: "",
          //     cardDescriptionEight: ""
          //   }
          // ]
        },
        {
          mainDescription: this.$t("Your news is interesting"),
          subDescriptionOne: this.$t("You do not have to write to attract the whole world. If your neighbour finds its interesting, your storey has great value"),
          subDescriptionTwo: "",
          readMore: "",
          image: "/neigbour1.jpg",
          link: "",
          component: "",
          color: "",
          // cardInfo:[
          //   {
          //     title: "Gonna be an add",
          //     image: "",
          //     cardDescriptionOne: "To Come soon",
          //     cardDescriptionTwo: "",
          //     cardDescriptionThree: "",
          //     cardDescriptionFour: "",
          //     cardDescriptionFive: "",
          //     cardDescriptionSix: "",
          //     cardDescriptionSeven: "",
          //     cardDescriptionEight: ""
          //   }
          // ]
        },
      ],
      chosenAdvert: [],
    }
  },
  beforeMount(){
    this.pickRandomAdvertisment()
  },
  methods:{
    pickRandomAdvertisment(){
      var advertismentChosen = Math.floor(Math.random() * this.advertisment.length);
      this.chosenAdvert = this.advertisment[advertismentChosen];
    }
  }
}
</script>